(function () {
  'use strict';
  if (window.LDReleaseBridgeLoaded || !window.LDReleaseAssets) return;
  window.LDReleaseBridgeLoaded = true;
  const assets = window.LDReleaseAssets;
  const key = 'lep-dom-configured-cart-v1';
  const nativeEnabled=window.LDCheckoutSettings?.nativeCartEnabled===true;
  let nativeManaged=false;
  let loading, openingCart, countRequest, countAgain=false;
  let stylesheetReady=false;
  const resources=new Map(),pendingHosts=new Set();
  const nativeHeader=document.getElementById('cart-drawer-toggle');
  const nativeCounters=[...document.querySelectorAll('#cart-drawer-toggle .thb-item-count')];
  let nativeCount=Number(nativeCounters[0]?.textContent.trim())||0;
  let paintedCount=nativeCount;
  document.documentElement.classList.toggle('ld-native-cart-header',Boolean(nativeHeader));
  function configuredQuantity() {
    try {
      const value=JSON.parse(localStorage.getItem(key)||'[]');
      return Array.isArray(value)?value.filter(line=>Number.isInteger(line?.quantity)&&line.quantity>0&&line.quote?.server?.token).reduce((sum,line)=>sum+line.quantity,0):0;
    } catch {return 0;}
  }
  function paintCount(count) {
    if(Number.isInteger(count)&&count>=0)nativeCount=count;
    const configured=nativeEnabled?0:configuredQuantity();
    paintedCount=nativeCount+configured;
    for(const counter of nativeCounters)if(counter.textContent!==String(paintedCount))counter.textContent=String(paintedCount);
    document.documentElement.classList.toggle('ld-configured-cart-active',configured>0||nativeManaged);
  }
  function actualCart(cart) {
    return cart && typeof cart==='object' && Array.isArray(cart.items) && (typeof cart.currency==='string' || Number.isInteger(cart.item_count));
  }
  function rememberCart(snapshot,publish=false) {
    if(!actualCart(snapshot?.cart))return false;
    const cart=snapshot.cart;
    window.LDNativeCartSnapshot=snapshot;
    nativeManaged=cart.items.some(line=>/^LDCART-/i.test(line.sku||'')||line.properties?._ld_native_receipt||line.properties?._ld_native_action);
    const count=Number.isInteger(cart.item_count)?cart.item_count:cart.items.reduce((sum,line)=>sum+(Number.isInteger(line.quantity)&&line.quantity>0?line.quantity:0),0);
    paintCount(count);
    if(publish)document.dispatchEvent(new CustomEvent('ld:native-cart-snapshot',{detail:snapshot}));
    if(nativeManaged)ensureReady().catch(()=>{});
    return true;
  }
  function refreshNativeCount() {
    if(countRequest){countAgain=true;return countRequest;}
    const route=window.Shopify?.routes?.root||'/';
    const prefix=/^\/(?:[a-zA-Z0-9-]+\/)*$/.test(route)?route:'/';
    const startedSnapshot=window.LDNativeCartSnapshot;
    countRequest=fetch(prefix+'cart.js',{credentials:'same-origin',cache:'no-store'}).then(response=>{if(!response.ok)throw new Error('cart_unavailable');return response.json();}).then(cart=>{
      const latestSnapshot=window.LDNativeCartSnapshot;
      if(latestSnapshot!==startedSnapshot&&actualCart(latestSnapshot?.cart))return latestSnapshot;
      const snapshot={cart,fetchedAt:Date.now(),source:'bridge'};
      if(!rememberCart(snapshot,true))throw new Error('cart_unavailable');
      return snapshot;
    }).catch(()=>null).finally(()=>{countRequest=null;if(countAgain){countAgain=false;refreshNativeCount();}});
    window.LDNativeCartBootstrap=countRequest;
    return countRequest;
  }
  document.addEventListener('ld:native-cart-snapshot',event=>{if(event.detail?.source==='client')rememberCart(event.detail);});
  function cartEvent(event) {
    const cart=event.detail?.rawCart||event.detail?.cart;
    if(actualCart(cart))rememberCart({cart,fetchedAt:Date.now(),source:'bridge'},true);
    else refreshNativeCount();
  }
  document.addEventListener('ld:cart-updated',event=>{
    const cart=event.detail?.rawCart||event.detail?.cart;
    if(actualCart(cart)){rememberCart({cart,fetchedAt:Date.now(),source:'client'});return;}
    if(typeof event.detail?.configuredNative==='boolean')nativeManaged=event.detail.configuredNative;
    paintCount(event.detail?.ordinaryCount);
  });
  for(const name of ['line-item:change:end','cart:refresh'])document.addEventListener(name,cartEvent);
  document.addEventListener('cart:item-added',event=>{
    cartEvent(event);
    if(hasConfigured())openCart();
  });
  // Habitat replaces this counter text after its asynchronous section render.
  // Observe only the existing counter, and never rewrite our own expected value.
  for(const counter of nativeCounters)new MutationObserver(()=>{
    const current=Number(counter.textContent.trim());
    if(Number.isInteger(current)&&current>=0&&current!==paintedCount){paintCount(current);if(hasConfigured())refreshNativeCount();}
  }).observe(counter,{childList:true,characterData:true,subtree:true});
  paintCount();
  function hasConfigured() {
    if(nativeEnabled||nativeManaged)return true;
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) && value.some(line => line?.quantity > 0 && line.quote?.server?.token);
    } catch { return false; }
  }
  function appendResource(tag, attributes) {
    const identity=tag+':'+(attributes.src||attributes.href);
    if(resources.has(identity))return resources.get(identity);
    const promise=new Promise((resolve, reject) => {
      const element = document.createElement(tag);
      Object.assign(element, attributes);
      element.setAttribute('data-ld-critical', '');
      element.onload = resolve;
      element.onerror = ()=>{resources.delete(identity);element.remove();reject(new Error('calculator_resource_unavailable'));};
      document.head.appendChild(element);
    });
    resources.set(identity,promise);
    return promise;
  }
  function waitForResources(promise) {
    return new Promise((resolve,reject)=>{
      // Keep a slow request in the resource map: removing a script cannot prevent
      // its late execution, and injecting it again could duplicate cart handlers.
      const timer=window.setTimeout(()=>{window.clearTimeout(timer);reject(new Error('calculator_resource_timeout'));},10000);
      promise.then(value=>{window.clearTimeout(timer);resolve(value);},error=>{window.clearTimeout(timer);reject(error);});
    });
  }
  function legacyScope(host) {
    return host.closest('.product-information--inner');
  }
  function showProduct(host) {
    if(!stylesheetReady){pendingHosts.add(host);return;}
    const scope = legacyScope(host);
    if (!scope) return;
    if(scope.__ldProductBoot&&!scope.__ldProductBoot.complete())return;
    scope.classList.add('ld-release-ready');
    host.hidden = false;
    const toggle = scope.querySelector('[data-ld-show-original]');
    if (toggle) { toggle.hidden = false; toggle.setAttribute('aria-expanded', 'false'); }
  }
  document.addEventListener('ld:ready', event => {
    const host = event.detail?.host;
    if (!host || event.detail.cartOnly) return;
    showProduct(host);
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-ld-show-original]');
    if (!toggle) return;
    const scope = toggle.closest('.product-information--inner');
    const host = scope?.querySelector('[data-ld-configurator-root]:not([data-ld-modal-root])');
    if (!scope || !host) return;
    const useOriginal = scope.classList.contains('ld-release-ready');
    scope.classList.toggle('ld-release-ready', !useOriginal);
    host.hidden = useOriginal;
    toggle.textContent = useOriginal ? assets.labels.calculator : assets.labels.original;
    toggle.setAttribute('aria-expanded', String(useOriginal));
  });
  const opener = document.createElement('button');
  opener.type = 'button';
  opener.className = 'ld-release-cart-access';
  opener.textContent = assets.labels.cart;
  const status = document.createElement('p');
  status.className = 'ld-release-load-status';
  status.setAttribute('role', 'status');
  status.hidden = true;
  if(!nativeHeader)document.body.append(opener);
  document.body.append(status);
  function ensureReady() {
    if (loading) return loading;
    loading = (async () => {
      let host = document.querySelector('[data-ld-configurator-root]:not([data-ld-modal-root])');
      if (!host) {
        host = document.createElement('div');
        host.dataset.ldConfiguratorRoot = '';
        host.dataset.productSource = 'shopify';
        host.dataset.cartOnly = 'true';
        host.className = 'ld-release-cart-root notranslate';
        host.setAttribute('translate', 'no');
        document.body.appendChild(host);
      }
      const stylesheet=appendResource('link', {rel:'stylesheet',href:assets.stylesheet}).then(()=>{
        stylesheetReady=true;
        for(const readyHost of pendingHosts)showProduct(readyHost);
        pendingHosts.clear();
      });
      const runtime=window.LDCart?Promise.resolve():appendResource('script',{src:assets.runtime,async:false});
      await waitForResources(Promise.all([stylesheet,runtime]));
      if (!window.LDCart) throw new Error('calculator_not_ready');
    })().catch(error => {
      loading = null;
      for(const scope of document.querySelectorAll('[data-ld-product-pending]'))scope.__ldProductBoot?.restore();
      status.textContent = assets.labels.error;
      status.hidden = !hasConfigured();
      throw error;
    });
    return loading;
  }
  function openCart() {
    if(openingCart)return openingCart;
    openingCart=(async()=>{
      status.textContent = assets.labels.wait;
      status.hidden = false;
      try {
        await ensureReady();
        document.getElementById('Cart-Drawer')?.classList.remove('active');
        document.body.classList.remove('open-cc');
        window.LDCart.open();
        status.hidden = true;
      } catch { status.textContent = assets.labels.error; }
    })().finally(()=>{openingCart=null;});
    return openingCart;
  }
  opener.addEventListener('click', openCart);
  function nativeDestination(anchor) {
    if (!anchor || anchor.hasAttribute('data-ld-native-cart') || anchor.target === '_blank' || anchor.hasAttribute('download')) return false;
    const url = new URL(anchor.href, window.location.href);
    return url.origin === window.location.origin && /^\/(?:[a-zA-Z0-9-]+\/)?(?:cart|checkout)\/?$/.test(url.pathname);
  }
  document.addEventListener('click', event => {
    if (!hasConfigured() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    const checkout = event.target.closest('button[name="checkout"],input[name="checkout"]');
    if (!checkout && !nativeDestination(anchor)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openCart();
  }, true);
  document.addEventListener('submit', event => {
    if (!hasConfigured()) return;
    if (event.submitter?.name !== 'checkout' && !/\/checkout\/?(?:\?|$)/.test(event.target.action || '')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openCart();
  }, true);
  window.addEventListener('storage', event => {
    if (event.key !== key&&event.key !== key+':native-writes-v1') return;
    paintCount();
    if (hasConfigured()) ensureReady().catch(() => {});
  });
  if(!rememberCart(window.LDNativeCartSnapshot))refreshNativeCount();
  if (document.querySelector('[data-ld-configurator-root]:not([data-ld-modal-root])') || nativeManaged || configuredQuantity()>0) ensureReady().catch(() => {});
})();
